'use client';

import { XMarkIcon } from '@heroicons/react/24/outline';
import StockDetailView from '@/components/stock-detail/StockDetailView';
import { ScreenerType } from '@/lib/screenerCriteria';

interface StockDetailModalProps {
  isin: string;
  onClose: () => void;
  /**
   * Active screener — drives the SMA-comparison gate used inside the
   * detail view. Defaults to `big_buy` for backwards compatibility.
   */
  screener?: ScreenerType;
}

/**
 * Modal wrapper around the shared {@link StockDetailView}. New callers
 * should prefer linking to `/big-buy-at-low/stock/[isin]` for a real
 * route; this component is preserved for tables that still want the
 * overlay behaviour (volume scanner, tick analysis, etc.).
 */
export default function StockDetailModal({
  isin,
  onClose,
  screener = 'big_buy',
}: StockDetailModalProps) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/50 overflow-auto">
      <StockDetailView
        isin={isin}
        screener={screener}
        cardClassName="rounded-2xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-900 p-6 max-w-7xl w-full mx-4 my-8 max-h-[90vh] overflow-auto"
        headerAction={
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
            aria-label="Close"
          >
            <XMarkIcon className="h-6 w-6 text-zinc-500 dark:text-zinc-400" />
          </button>
        }
      />
    </div>
  );
}
